export const YLDRAbi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'asset',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
    ],
    name: 'getUserReserveData',
    outputs: [
      {
        internalType: 'uint256',
        name: 'currentYTokenBalance',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'currentVariableDebt',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'scaledVariableDebt',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'liquidityRate',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'usageAsCollateralEnabled',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
] as const
